module.exports = __webpack_public_path__ + "d32a8b8ca3a07097c0c07f62fff2e744.svg";